// Development configuration - loads sensitive vars from Vite env
// This file sets up window globals for local development

export function setupDevConfig() {
  if (typeof window === "undefined") return;

  // Only set if not already defined (allows override from HTML)
  const setIfUndefined = (key: string, value: string | undefined) => {
    if (!(window as any)[key] && value) {
      (window as any)[key] = value;
    }
  };

  // Sensitive vars from .env
  setIfUndefined("FIINDER_API_URL", import.meta.env.VITE_PEATS_API_URL);
  if (import.meta.env.DEV) {
    setIfUndefined(
      "FIINDER_COMPANY_TOKEN",
      import.meta.env.VITE_PEATS_COMPANY_TOKEN ||
        import.meta.env.VITE_FIINDER_COMPANY_TOKEN,
    );
  }

  // Non-sensitive defaults for dev
  setIfUndefined("FIINDER_AGENT_NAME", "Peaty");
  setIfUndefined("FIINDER_AGENT_ROLE", "The artificial intelligence of PEATS");
  setIfUndefined("FIINDER_COMPANY_MAIN_COLOR", "#2d6a4f");
  setIfUndefined("FIINDER_CHAT_INTRO_MESSAGE", "I'm Peaty — how can I help you?");
  setIfUndefined("FIINDER_CHAT_LAUNCHER_CALL_TO_ACTION", "Let's chat!");
  setIfUndefined("FIINDER_SEARCH_PLACEHOLDER", "Search in PEATS...");
}
